import { render, staticRenderFns } from "./BookingRejectConformationDialog.vue?vue&type=template&id=5c063067&scoped=true&"
import script from "./BookingRejectConformationDialog.vue?vue&type=script&lang=js&"
export * from "./BookingRejectConformationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c063067",
  null
  
)

export default component.exports